export var EventDocumentType;
(function (EventDocumentType) {
    EventDocumentType[EventDocumentType["BackgroundImage"] = 0] = "BackgroundImage";
    EventDocumentType[EventDocumentType["Logo"] = 1] = "Logo";
    EventDocumentType[EventDocumentType["FloorMap"] = 2] = "FloorMap";
    EventDocumentType[EventDocumentType["Gallery"] = 3] = "Gallery";
    EventDocumentType[EventDocumentType["PrivacyDocument"] = 3] = "PrivacyDocument";
    EventDocumentType[EventDocumentType["TermsAndCondition"] = 4] = "TermsAndCondition";
    EventDocumentType[EventDocumentType["PartnershipAgreement"] = 9] = "PartnershipAgreement";
    EventDocumentType[EventDocumentType["NonDisclosureAgreement"] = 10] = "NonDisclosureAgreement";
    EventDocumentType[EventDocumentType["HealthSafetyPolicy"] = 11] = "HealthSafetyPolicy";
    EventDocumentType[EventDocumentType["DataProtectionPolicy"] = 12] = "DataProtectionPolicy";
    EventDocumentType[EventDocumentType["SecurityPolicy"] = 13] = "SecurityPolicy";
    EventDocumentType[EventDocumentType["Internal"] = 18] = "Internal";
    EventDocumentType[EventDocumentType["External"] = 19] = "External";
    EventDocumentType[EventDocumentType["EventStoryImage"] = 20] = "EventStoryImage";
    EventDocumentType[EventDocumentType["ThankYouImage"] = 21] = "ThankYouImage";
    EventDocumentType[EventDocumentType["SpheresMaster"] = 23] = "SpheresMaster";
    EventDocumentType[EventDocumentType["HappinessManager"] = 24] = "HappinessManager";
    EventDocumentType[EventDocumentType["All"] = 25] = "All";
})(EventDocumentType || (EventDocumentType = {}));
